import { EncyclopediaMessage } from 'types';
import WorkspaceManager from 'managers/workspace.manager';

type Handlers = Partial<{
  [P in keyof EncyclopediaMessage]: (data: EncyclopediaMessage[P]) => void
}>;

const HANDLERS: Handlers = {
  addToWorkspace: ({ id }) => WorkspaceManager.addToWorkspace(id),
};

export default HANDLERS;
